<template>
  <v-footer :fixed="true" app></v-footer>
</template>

<script>
export default {
  name: 'AppFooter',

  data: () => ({
    //
  })
};
</script>
